import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  private tokenKey = 'auth_token';

  private currentJwtPayloadSubject =
    new BehaviorSubject<any | null>(null);

  currentJwtPayload$ =
    this.currentJwtPayloadSubject.asObservable();

  constructor() {

    const token = this.getJWTString();

    if (token) {

      const payload = this.decodeJWT(token);

      this.currentJwtPayloadSubject.next(payload);
    }
  }

  saveJWT(token: string) {

    localStorage.setItem(this.tokenKey, token);

    const payload = this.decodeJWT(token);

    this.currentJwtPayloadSubject.next(payload);
  }

  removeJWT() {

    localStorage.removeItem(this.tokenKey);

    this.currentJwtPayloadSubject.next(null);
  }

  getJWTString(): string {

    return localStorage.getItem(this.tokenKey) || '';
  }

  decodeJWT(token?: string): any | null {

    try {

      return jwtDecode(token || this.getJWTString());

    } catch {

      return null;
    }
  }

  isExpired(payload?: any): boolean {

    if (!payload) {
      return true;
    }

    const now = Math.floor(Date.now() / 1000);

    return payload.exp < now;
  }
}